import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from '../../constants/breakpoints';

export default createUseStyles((theme) => ({
  signInContainer: {
    backgroundColor: colors.white,
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: 16,
    paddingRight: 16,
    [`@media (max-width: ${breakpoints.md}px)`]: {
      alignItems: "start",
      padding: "60px 20px 30px",
    },
  },
  signInContent: {
    maxWidth: 360,
    width: "100%",
    textAlign: "center",
    fontFamily: "'Inter', sans-serif",
  },
  logo: {
    margin: "0 auto 24px",
    display: "block",
  },
  signInTitle: {
    fontSize: 30,
    fontWeight: 600,
    lineHeight: "38px",
    marginBottom: "12px",
    textAlign: "center",
    fontFamily: "'Inter', sans-serif",
  },
  signInSubtitle: {
    fontSize: 14,
    color: "#555",
    marginBottom: 24,
  },
  signInButton: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: 500,
    fontSize: 16,
  },
}));